import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "text-[var(--el-text-color-secondary)] text-12px line-clamp-1"
};
const _hoisted_3 = {
  class: "text-[var(--el-text-color-secondary)] text-12px"
};
const _hoisted_4 = ["innerHTML"];
import { inject } from 'vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Index'
  },
  __name: 'index',
  setup(__props) {
    const currentSong = inject('currentSong', {});
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      return _openBlock(), _createBlock(_component_ContentWrap, {
        class: "w-300px mb-[0!important] line-height-24px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          src: _unref(currentSong).imageUrl
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(currentSong).title), 1), _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(currentSong).desc), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(currentSong).date), 1), _createVNode(_component_el_button, {
          size: "small",
          round: "",
          class: "my-6px"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("信息复用")])),
          _: 1
        }), _createElementVNode("div", {
          class: "text-[var(--el-text-color-secondary)] text-12px",
          innerHTML: _unref(currentSong).lyric
        }, null, 8, _hoisted_4)]),
        _: 1
      });
    };
  }
});